import clsx from 'clsx';
import Structure from 'components/corporatiu/Structure';
import __isEmpty from 'lodash/isEmpty';
import styles from './columna.module.scss';

export default function Columna(props) {
    const { columnes, tipus, estil, className, tag = 'div', numColumnsRow = 12 } = props;
    const columnClass = 'col' + columnes;
    const TagSeo = tag;

    const styleColumn = clsx({
        [styles.columna]: true,
        [styles[columnClass]]: true,
        [styles[tipus]]: !__isEmpty(tipus),
        [styles[estil]]: !__isEmpty(estil),
        [styles[className]]: !__isEmpty(className)
    });

    return (
        <TagSeo className={styleColumn}>
            <Structure {...props} numColumnsRow={numColumnsRow} />
        </TagSeo>
    );
}
